import { FC, KeyboardEvent, useRef } from "react";
import { Button, FormControl, Stack, TextLink } from "@contentful/f36-components";
import { CloudUploadIcon, DoneIcon } from "@contentful/f36-icons";

export interface UploadGlossaryButtonProps {
    value: File | null;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    isLoading: boolean;
    errorMessage: string | null;
}

export const UploadGlossaryButton: FC<UploadGlossaryButtonProps> = ({
    value,
    onChange,
    isLoading,
    errorMessage,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleButtonKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === "Enter" && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Stack>
            <Button
                isLoading={isLoading}
                variant={value ? "positive" : "primary"}
                startIcon={value ? <DoneIcon /> : <CloudUploadIcon />}
                style={{ position: "relative" }}
                onKeyDown={handleButtonKeyDown}>
                Upload glossary file
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={onChange}
                    tabIndex={-1}
                    style={{
                        opacity: 0,
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                    }}
                />
            </Button>
            {errorMessage ? (
                <FormControl.ValidationMessage>{errorMessage}</FormControl.ValidationMessage>
            ) : (
                <FormControl.HelpText>
                    Please only upload a glossary file downloaded{" "}
                    <TextLink
                        href="https://support.deepl.com/hc/articles/360021634540-About-the-glossary"
                        target="_blank"
                        rel="noopener noreferrer">
                        from DeepL
                    </TextLink>
                    .
                </FormControl.HelpText>
            )}
        </Stack>
    );
};
